module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "preloader__background"
  }), _vm._v(" "), _c('div', {
    staticClass: "preloader__animation"
  }, [_c('div', {
    staticClass: "preloader__icon"
  }, [_c('PreloaderIcon')], 1), _vm._v(" "), _c('div', {
    staticClass: "preloader__text"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('p', {
    key: _vm.preloaderTextIdx,
    ref: "preload",
    domProps: {
      "innerHTML": _vm._s(_vm.preloaderText())
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6871e6e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/1-common/Preloader.vue
// module id = 542
// module chunks = 1